import React, { ReactElement } from 'react';
import { RecoveryResetForm } from '../../features/auth/RecoveryResetForm';

interface ContentProps {
  resetPasswordToken?: string;
  email?: string;
}

function Content({ resetPasswordToken, email }: ContentProps): ReactElement {
  return <RecoveryResetForm resetPasswordToken={resetPasswordToken} email={email} />;
}

export { Content };
